export default __webpack_public_path__ + "c3f3b4c53bb83c3e35a087e8c068deed.svg";